<template>
  <div class="box">
    <commonHeader heading="知识/技能点搜索定位">
    </commonHeader>
    <div class="box-echart">
      <div class="box-header">
        <v-text-field class="text-field-width" v-model="queryParams.name" placeholder="知识/技能名称" hide-details solo
          clearable></v-text-field>
        <v-select class="select-width" v-model="queryParams.select" :items="selectMetaListData" label="工种"
          color="#4caf50" hide-details solo></v-select>
        <v-select class="select-width" v-model="queryParams.selectProfessional" :items="selectProfessionalData" label="专业群"
          color="#4caf50" hide-details solo></v-select>
        <v-text-field class="text-field-width" v-model="queryParams.name" placeholder="请输入创建人" hide-details solo
          clearable></v-text-field>
        <v-btn depressed color="primary">
          搜索
        </v-btn>
        <v-btn depressed>
          清空
        </v-btn>
      </div>
      <div class="box-echart">
        <div id="container" class="graph-container"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import CommonHeader from '@/components/DataService/CommonHeader.vue';
import G6 from '@/utils/g6.js';

export default {
  components: {
    CommonHeader
  },
  data() {
    return {
      queryParams: {
        name: '',
        name1: '',
        select: '',
      },
      selectMetaListData: [
        { text: '电工', value: 1 },
        { text: '焊工', value: 2 },
        { text: '钳工', value: 3 },
        { text: '车工', value: 4 },
        { text: '铣工', value: 5 },
        { text: '装配工', value: 6 },
        { text: '木工', value: 7 },
        { text: '砌筑工', value: 8 },
        { text: '管道工', value: 9 },
        { text: '起重工', value: 10 }
      ],
      selectProfessionalData: [
        { text: '机械制造与自动化', value: 1 },
        { text: '电气自动化技术', value: 2 },
        { text: '模具设计与制造', value: 3 },
        { text: '数控技术', value: 4 },
        { text: '工业机器人技术', value: 5 },
        { text: '智能制造工程技术', value: 6 },
        { text: '机电一体化技术', value: 7 },
        { text: '电子信息工程技术', value: 8 },
        { text: '汽车制造与装配技术', value: 9 },
        { text: '新能源汽车技术', value: 10 }
      ],
    };
  },

  created() {

  },

  mounted() {
    // this.getTableList()
    this.getG6()
    // this.getG666()
  },

  methods: {
    getG6() {
      const data = {
        nodes: [
          // 蓝绿色节点（安装相关）
          { 
            id: '开关插座安装规范', 
            label: '开关插座\n安装规范', 
            style: { fill: '#8FE3CF' } 
          },
          { 
            id: '安装开关', 
            label: '安装开关', 
            style: { fill: '#8FE3CF' } 
          },
          { 
            id: '安装插座', 
            label: '安装插座', 
            style: { fill: '#8FE3CF' } 
          },
          { 
            id: '插座与安装接线规定', 
            label: '插座与安装\n接线规定', 
            style: { fill: '#8FE3CF' } 
          },
          { 
            id: '安装单联双控开关', 
            label: '安装单联\n双控开关', 
            style: { fill: '#B5E6D8' } 
          },
          { 
            id: '安装双联单控开关', 
            label: '安装双联\n单控开关', 
            style: { fill: '#B5E6D8' } 
          },
          { 
            id: '三孔插座的安装', 
            label: '三孔插座\n的安装', 
            style: { fill: '#B5E6D8' } 
          },
          // 黄色节点
          { 
            id: '建筑电气施工技术', 
            label: '建筑电气\n施工技术', 
            style: { fill: '#FFD93D' } 
          },
          // 橙色节点
          { 
            id: '插座理论知识点', 
            label: '插座理论\n知识点', 
            style: { fill: '#FFB562' } 
          },
          { 
            id: '插座的分类', 
            label: '插座的分类', 
            style: { fill: '#FFB562' } 
          },
          // 新增蓝绿色节点（安装相关）
          { id: '照明电路安装', label: '照明电路\n安装', style: { fill: '#8FE3CF' } },
          { id: '配电箱安装', label: '配电箱安装', style: { fill: '#8FE3CF' } },
          { id: '接地系统安装', label: '接地系统\n安装', style: { fill: '#8FE3CF' } },
          { id: '线管敷设规范', label: '线管敷设\n规范', style: { fill: '#8FE3CF' } },
          
          // 新增浅蓝绿色节点（具体安装步骤）
          { id: '明装线管敷设', label: '明装线管\n敷设', style: { fill: '#B5E6D8' } },
          { id: '暗装线管敷设', label: '暗装线管\n敷设', style: { fill: '#B5E6D8' } },
          { id: '防水插座安装', label: '防水插座\n安装', style: { fill: '#B5E6D8' } },
          { id: '接地端子安装', label: '接地端子\n安装', style: { fill: '#B5E6D8' } },
          { id: '漏电保护器安装', label: '漏电保护器\n安装', style: { fill: '#B5E6D8' } },
          
          // 新增黄色节点（核心技术）
          { id: '室内配线技术', label: '室内配线\n技术', style: { fill: '#FFD93D' } },
          { id: '电气安全技术', label: '电气安全\n技术', style: { fill: '#FFD93D' } },
          { id: '电路故障检测', label: '电路故障\n检测', style: { fill: '#FFD93D' } },
          
          // 新增橙色节点（理论知识）
          { id: '电工基础理论', label: '电工基础\n理论', style: { fill: '#FFB562' } },
          { id: '电路原理', label: '电路原理', style: { fill: '#FFB562' } },
          { id: '电气材料学', label: '电气材料学', style: { fill: '#FFB562' } },
          { id: '安全规范', label: '安全规范', style: { fill: '#FFB562' } }
        ],
        edges: [
          // 开关插座安装规范的关系
          { source: '开关插座安装规范', target: '安装开关' },
          { source: '开关插座安装规范', target: '安装单联双控开关' },
          { source: '开关插座安装规范', target: '安装双联单控开关' },
          { source: '开关插座安装规范', target: '插座与安装接线规定' },
          
          // 安装开关和插座的关系
          { source: '安装开关', target: '建筑电气施工技术' },
          { source: '安装插座', target: '建筑电气施工技术' },
          
          // 插座安装相关
          { source: '安装插座', target: '三孔插座的安装' },
          { source: '安装插座', target: '插座与安装接线规定' },
          { source: '三孔插座的安装', target: '插座与安装接线规定' },
          
          // 理论知识点关系
          { source: '插座理论知识点', target: '安装插座' },
          { source: '插座的分类', target: '插座理论知识点' },
          
          // 新增安装规范关系
          { source: '线管敷设规范', target: '明装线管敷设' },
          { source: '线管敷设规范', target: '暗装线管敷设' },
          { source: '配电箱安装', target: '漏电保护器安装' },
          { source: '接地系统安装', target: '接地端子安装' },
          
          // 新增技术关联
          { source: '建筑电气施工技术', target: '室内配线技术' },
          { source: '建筑电气施工技术', target: '电气安全技术' },
          { source: '建筑电气施工技术', target: '电路故障检测' },
          
          // 新增理论知识关联
          { source: '电工基础理论', target: '电路原理' },
          { source: '电工基础理论', target: '电气材料学' },
          { source: '电工基础理论', target: '安全规范' },
          
          // 交叉关联
          { source: '照明电路安装', target: '室内配线技术' },
          { source: '电气安全技术', target: '安全规范' },
          { source: '配电箱安装', target: '电路故障检测' },
          { source: '接地系统安装', target: '电气安全技术' },
          { source: '防水插座安装', target: '安全规范' },
          { source: '电路原理', target: '电路故障检测' }
        ]
      };

      const width = document.getElementById('container').scrollWidth;
      const height = document.getElementById('container').scrollHeight || 800;
      const graph = new G6.Graph({
        container: 'container',
        width,
        height,
        modes: {
          default: ['drag-canvas', 'zoom-canvas', 'drag-node'],
        },
        defaultNode: {
          size: 50,
          type: 'circle',
          style: {
            fill: '#5B8FF9',
            stroke: '#fff',
            lineWidth: 2,
            shadowColor: '#ccc',
            shadowBlur: 10,
            cursor: 'pointer',
          },
          labelCfg: {
            style: {
              fill: '#000000',
              fontSize: 14,
              fontWeight: 500,
              background: {
                fill: '#ffffff',
                padding: [4, 8],
                radius: 4,
              },
              textBaseline: 'middle',
              textAlign: 'center',
              wordWrap: true,
              width: 100,
            },
            position: 'bottom',
            offset: 10,
          },
        },
        defaultEdge: {
          type: 'cubic',
          style: {
            stroke: '#aaa',
            lineWidth: 1.5,
            opacity: 0.6,
            // endArrow: {
            //   path: G6.Arrow.triangle(8, 8, 0),
            //   fill: '#aaa',
            //   stroke: '#aaa'
            // },
          },
          labelCfg: {
            autoRotate: true,
            style: {
              fill: '#666',
              fontSize: 12,
            },
          },
          curveOffset: 30,
        },
        layout: {
          type: 'force',
          preventOverlap: true,
          linkDistance: 150,
          nodeStrength: -100,
          edgeStrength: 0.5,
          collideStrength: 1,
          alpha: 0.3,
          alphaDecay: 0.028,
          alphaMin: 0.01,
          forceSimulation: null,
          nodeSize: [150, 150],
          onTick: () => {
            console.log('ticking');
          },
          onLayoutEnd: () => {
            console.log('force layout done');
          },
        },
        animate: true,
        animateCfg: {
          duration: 500,
          easing: 'easeCubic',
        },
      });

      graph.on('node:mouseenter', (evt) => {
        const { item } = evt;
        graph.setItemState(item, 'hover', true);
      });

      graph.on('node:mouseleave', (evt) => {
        const { item } = evt;
        graph.setItemState(item, 'hover', false);
      });

      graph.updateItem = (item, cfg) => {
        if (item.hasState('hover')) {
          const group = item.getContainer();
          group.find(g => g.get('name') === 'circle-shape').attr('shadowColor', '#666');
          group.find(g => g.get('name') === 'circle-shape').attr('shadowBlur', 20);
        } else {
          const group = item.getContainer();
          group.find(g => g.get('name') === 'circle-shape').attr('shadowColor', '#ccc');
          group.find(g => g.get('name') === 'circle-shape').attr('shadowBlur', 10);
        }
      };

      graph.data(data);
      graph.render();

      window.addEventListener('resize', () => {
        if (!graph || graph.get('destroyed')) return;
        const width = document.getElementById('container').scrollWidth;
        const height = document.getElementById('container').scrollHeight || 800;
        graph.changeSize(width, height);
      });
    },
    getTableList() {
      var chartDom = document.getElementById('main');
      var myChart = echarts.init(chartDom);
      var option;

      const data = [];
      for (let i = 0; i <= 360; i++) {
        let t = (i / 180) * Math.PI;
        let r = Math.sin(2 * t) * Math.cos(2 * t);
        data.push([r, i]);
      }
      option = {
        title: {
          text: 'Two Value-Axes in Polar'
        },
        legend: {
          data: ['line']
        },
        polar: {
          center: ['50%', '54%']
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        angleAxis: {
          type: 'value',
          startAngle: 0
        },
        radiusAxis: {
          min: 0
        },
        series: [
          {
            coordinateSystem: 'polar',
            name: 'line',
            type: 'line',
            showSymbol: false,
            data: data
          }
        ],
        animationDuration: 2000
      };

      option && myChart.setOption(option);
    },

  }
}
</script>

<style scoped>
.box {
  padding: 0 15px;

  .box-title {
    font-size: 22px;
    height: 35px;
    line-height: 35px;
  }

  .box-echart {
    .box-header {
      padding: 10px 0;

      .text-field-width {
        display: inline-block;
        width: 200px;
        margin: 0 5px 5px 0;
      }

      .select-width {
        display: inline-block;
        width: 260px;
        margin: 0 5px 5px 0;
      }

      .date-width {
        display: inline-block;
        width: 260px;
        margin: 0 5px 5px 0;
      }

      .v-btn {
        margin: 5px;
      }
    }
  }
}

.graph-container {
  width: 100%;
  height: 800px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background: #fff;
}
</style>